module.exports = __webpack_public_path__ + "static/media/30.c52c8871.png";